import React, { useEffect, useState, useRef } from 'react';
import VerHistorias from './VerHistorias';
import './HistoriasPremiumBanner.css';

const HistoriasPremiumBanner = () => {
  const [perfilesPremium, setPerfilesPremium] = useState([]);
  const [perfilSeleccionado, setPerfilSeleccionado] = useState(null);
  const scrollRef = useRef(null);
  const [tieneOverflow, setTieneOverflow] = useState(false);

useEffect(() => {
  const el = scrollRef.current;
  if (!el) return;
  const check = () => setTieneOverflow(el.scrollWidth > el.clientWidth);
  check();
  window.addEventListener('resize', check);
  return () => window.removeEventListener('resize', check);
}, [perfilesPremium]);

  const API_VIEWER = process.env.REACT_APP_HISTORIAS_VIEWER_URL;
  const UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL;

  useEffect(() => {
    fetch(`${API_VIEWER}/get_historias_premium.php`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setPerfilesPremium(data.data || []);
      })
      .catch(err => console.error('Error cargando historias premium:', err));
  }, [API_VIEWER]);

  const handleFlecha = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  if (perfilesPremium.length === 0) return null;

return (
    <>
      <div className="hpb-banner">
        <div className="hpb-titulo">HISTORIAS PREMIUM</div>
        <div className={`hpb-scroll-wrapper${tieneOverflow ? ' hpb-tiene-overflow' : ''}`}>
          <div className="hpb-circulos" ref={scrollRef}>
            {perfilesPremium.map((perfil) => (
              <div
                key={perfil.usuario_id}
                className="hpb-circulo-wrapper"
                onClick={() => setPerfilSeleccionado(perfil)}
              >
                <div className="hpb-circulo-anillo">
                  <div className="hpb-circulo-inner">
                    {perfil.fotos ? (
                      <img
                        src={`${UPLOADS_URL}/ID_${perfil.usuario_id}/${perfil.fotos}?v=${perfil.usuario_id}`}
                        alt={perfil.nombre}
                        className="hpb-circulo-img"
                        draggable={false}
                        onContextMenu={(e) => e.preventDefault()}
                      />
                    ) : (
                      <div className="hpb-circulo-vacio">
                        <span>{perfil.nombre?.charAt(0)}</span>
                      </div>
                    )}
                  </div>
                </div>
                <span className="hpb-nombre">{perfil.nombre}</span>
              </div>
            ))}
          </div>
{perfilesPremium.length > 3 && (
            <button className="hpb-flecha" onClick={handleFlecha}>➜</button>
          )}
        </div>
      </div>

      {perfilSeleccionado && (
        <VerHistorias
          usuarioId={perfilSeleccionado.usuario_id}
          nombrePerfil={perfilSeleccionado.nombre}
          fotoPerfil={
            perfilSeleccionado.fotos
              ? `${UPLOADS_URL}/ID_${perfilSeleccionado.usuario_id}/${perfilSeleccionado.fotos}`
              : null
          }
          esCreador={false}
          onClose={() => setPerfilSeleccionado(null)}
        />
      )}
    </>
  );
};

export default HistoriasPremiumBanner;